<template>
    <select v-bind:name="name" :required="!!required" class="select2 form-control"></select>
</template>

<style src="select2/dist/css/select2.min.css"></style>

<script>
    import Select2 from 'select2';
    import messages from '../../lang';

    export default {
        name: "Select2",
        props: {
            options: {
                type: String,
                required: true
            },
            value: {
                type: String | Array
            },
            name: {
                type: String,
                required: true,
            },
            multiple: {
                type: Boolean,
                default: false,
                required: false,
            },
            required: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        data() {
            return {
                selectData: JSON.parse(this.options),
                selectedValue: this.multiple ? JSON.parse(this.value) : this.value,
            }
        },
        beforeMount() {
        },
        mounted() {
            $(this.$el).select2({
                data: this.selectData,
                dropdownAutoWidth: true,
                closeOnSelect: !this.multiple,
                multiple: this.multiple,
                allowClear: true,
                language: document.documentElement.lang,
                placeholder: messages[document.documentElement.lang]["select_option"],
            });

            $(this.$el).val(this.selectedValue).trigger('change')
        },
        watch: {
            value: function (value) {
                // update value
                $(this.$el).val(value).trigger('change');
            },
            options: function (options) {
                // update options
                $(this.$el).empty().trigger('change');
                $(this.$el).select2({data: this.selectData});
            }
        },
        destroyed: function () {
            $(this.$el).off().select2('destroy')
        },
        computed: {}
    }
</script>

<style>
    select {
        width: 100%;
    }

    .select2-selection--multiple .select2-selection__choice {
        background-color: #343A40 !important;
        border: 1px solid #000;
    }

    .select2-container--default .select2-selection--single{
        height: 45px;
        background: #F3F3F3;
        color: rgba(0, 0, 0, 0.8);
        font-size: 14px;
        border-radius: 2px;
        box-shadow: none !important;
        border: 1px solid rgba(0, 0, 0, 0.1);
    }

    select.select2{
        position: static !important;
        outline:none !important;
    }

    /* test*/
    select:invalid.is-invalid + .select2-container > span.selection > span.select2-selection {
        border-color: #dc3545;
    }

    select:invalid.is-invalid + .select2-container--focus > span.selection > span.select2-selection {
        border-color: #dc3545;
        box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
    }
/*
    select:valid + .select2-container > span.selection > span.select2-selection {
        border-color: #28a745;
    }

    select:valid + .select2-container--focus > span.selection > span.select2-selection {
        border-color: #28a745;
        box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
    }*/
</style>
